/*
 * Saves the cart's PO number (cart attribute "PO Number") as the customer types, so it survives
 * cart re-renders and is on the cart before checkout. The field itself is snippets/po-number-field.liquid.
 */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let timer = null;
  let pending = null;
  let lastSaved = null;

  function save(value) {
    clearTimeout(timer);
    if (value === lastSaved) return pending || Promise.resolve();
    lastSaved = value;
    pending = fetch(`${root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'PO Number': value } }),
    })
      .catch((err) => console.warn('[PO number]', err))
      .finally(() => {
        pending = null;
      });
    return pending;
  }

  // Keep every PO field on the page (drawer and cart page) in step.
  function sync(source) {
    document.querySelectorAll('[data-po-number]').forEach((input) => {
      if (input !== source) input.value = source.value;
    });
  }

  document.addEventListener('input', (event) => {
    const input = event.target.closest && event.target.closest('[data-po-number]');
    if (!input) return;
    sync(input);
    clearTimeout(timer);
    timer = setTimeout(() => save(input.value.trim()), 500);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest && event.target.closest('[data-po-number]');
    if (input) save(input.value.trim());
  });

  // Make sure the latest value is saved before leaving for checkout (covers checkout links too).
  document.addEventListener(
    'click',
    (event) => {
      const checkout = event.target.closest && event.target.closest('[name="checkout"], a[href*="/checkout"]');
      const input = document.querySelector('[data-po-number]');
      if (!checkout || !input || input.value.trim() === lastSaved) return;
      event.preventDefault();
      save(input.value.trim()).then(() => {
        if (checkout.tagName === 'A') window.location.href = checkout.href;
        else checkout.click();
      });
    },
    true,
  );

  const first = document.querySelector('[data-po-number]');
  if (first) lastSaved = first.value.trim();
})();
